import { defaultSlickResponsive } from '@gn-audio/angularjs-components/slick/constants/default-slick-responsive';
import { IHasSlickSliderScope } from '@gn-audio/angularjs-components/slick/models/has-slick-slider-scope';
import { fetchFamilyAccessories } from '@gn-audio/core/api/product-catalogue/fetch-family-accessories';
import { fetchGroupAccessories } from '@gn-audio/core/api/product-catalogue/fetch-group-accessories';
import { IProductAccessory } from '@gn-audio/core/api/product-catalogue/models/product-accessory';
import { ProductType } from '@gn-audio/core/common/enums';

interface IAccessoriesSpotScope extends ng.IScope, IHasSlickSliderScope {
  accessories?: IProductAccessory[];
  productId?: string;
  productType?: ProductType;
}

/**
 * @deprecated Should be converted into component!
 */
export class AccessoriesSpotController implements ng.IController {
  public static $inject = ['$scope', '$q'];

  constructor(private $scope: IAccessoriesSpotScope, private $q: ng.IQService) {
    this.$scope
      .$watch('productId', (): void => {
        let promise: Promise<IProductAccessory[]>;

        switch (this.$scope.productType) {
          case ProductType.Family:
            promise = fetchFamilyAccessories(Number(this.$scope.productId));
            break;

          case ProductType.Group:
            promise = fetchGroupAccessories(Number(this.$scope.productId));
            break;

          default:
            break;
        }

        if (promise !== undefined) {
          this.$q
            .when(promise)
            .then((accessories: IProductAccessory[]) => {
              this.$scope.accessories = accessories;
            });
        }
      });
  }

  public $onInit() {
    this.$scope.responsive = defaultSlickResponsive;
  }
}
